import styled, { css } from 'styled-components';

export const $NestedConditionGroupWrapper = styled.div<{ nested?: boolean }>`
  ${props =>
    props.nested &&
    css`
      padding: 8px;
      padding-left: 16px;
      border-radius: 6px; // 6px
      border: 1px solid ${props => props.theme.colorBorder};
      /* background-color: ${props => props.theme['geekblue-1']}; */
      width: auto;
    `}
`;
